import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizBanner from "../../../../styles/img/quiz-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBaner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import Footer from "../../components/footer/Footer";
import { UiBlueBox } from "../../../_uiComponents/common/UiBlueBox";
import { Button } from "react-bootstrap";
import { QuestionLinks } from "../../../_uiComponents/common/QuestionLinks";
import { CircleTick } from "../../../../styles/img/svg/CircleTick";
import { UiQuestionWrapper } from "../../../_uiComponents/common/UiQuestionWrapper";
import { ImageQuestionAnswers } from "./Views/ImageQuestionAnswers";
import { ImageQuestionAnswerMultiple, ImageQuestionAnswerRadio } from "./Views/ImageQuestionRadio";
import { NeedAHelp } from "./Views/NeedAHelp";
import questionPhoto from '../../../../styles/img/knowledge-progress.jpg';
import questionPhoto3 from "../../../../styles/img/spin-win-2.jpg";
import questionPhoto4 from "../../../../styles/img/spin-win-3.jpg";
import questionPhoto5 from "../../../../styles/img/spin-win-4.jpg";

export const TemplateQUestionImageMultipleSelect = (props) => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Volvo 4x4 Programme"
                    description="Let’s sharpen up your knowledge with fast informative quiz!"
                    sliderCardImage={quizBanner}
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="   Volvo 4x4 Quiz"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-img-q-template-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-img-q-template-page__links">

                                    <UiBlueBox >
                                        <p>Questions Remaining</p>
                                        <h3>4/15</h3>
                                    </UiBlueBox>

                                    <QuestionLinks className="sb-green-links">
                                        <li className="active"><a href="#"> <CircleTick /> My Progress</a></li>
                                        <li><a href="#"><CircleTick />  Section 1</a></li>
                                        <li><a href="#"><CircleTick />  Section 2</a></li>
                                        <li><a href="#"><CircleTick />  Section 3</a></li>
                                        <li><a href="#"><CircleTick />  Section 4</a></li>
                                        <li><a href="#"><CircleTick />  Section 5</a></li>
                                    </QuestionLinks>


                                </UiCol>
                                <UiCol lg="9" className="sb-img-q-template-page__content">
                                    <UiQuestionWrapper>
                                        <h3><span>Question 4:</span> What’s the name of name of the new 2022 Lexus 4x4 range?</h3>

                                        <p className="sb-1-instruction">Select one of the following:</p>

                                        <ImageQuestionAnswers>

                                            <ImageQuestionAnswerMultiple
                                                id="radio-1"
                                                name="radio"
                                                for="radio-1"
                                                image={questionPhoto} />

                                            <ImageQuestionAnswerMultiple
                                                id="radio-2"
                                                name="radio"
                                                for="radio-2"
                                                image={questionPhoto4} />

                                            <ImageQuestionAnswerMultiple
                                                id="radio-3"
                                                name="radio"
                                                for="radio-3"
                                                image={questionPhoto3} />

                                            <ImageQuestionAnswerMultiple
                                                id="radio-4"
                                                name="radio"
                                                for="radio-4"
                                                image={questionPhoto4} />

                                            <ImageQuestionAnswerMultiple
                                                id="radio-5"
                                                name="radio"
                                                for="radio-5"
                                                image={questionPhoto5} />

                                            <ImageQuestionAnswerMultiple
                                                id="radio-6"
                                                name="radio"
                                                for="radio-6"
                                                image={questionPhoto} />

                                        </ImageQuestionAnswers>

                                        <Button className="sb-geen-btn">Submit?</Button>
                                    </UiQuestionWrapper>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <NeedAHelp />

                <Footer />

            </UiMainWrapper>


        </>
    )
}